export const APP_NAME = 'MUZLY';

/**
 * The app's single scroll container. The document itself never scrolls, so
 * anything that reads or writes a scroll position has to target this element —
 * page transitions, scroll restoration, pull-to-refresh. Kept in one place
 * because a rename that misses a call site fails silently, not at compile time.
 */
export const APP_SCROLL_CLASS = 'app-scroll';
export const APP_SCROLL_SELECTOR = `.${APP_SCROLL_CLASS}`;

export const STORAGE_KEYS = {
  THEME: 'muzly_theme',
  LANGUAGE: 'muzly_language',
  ACCESS_TOKEN: 'muzly_access_token',
  REFRESH_TOKEN: 'muzly_refresh_token',
} as const;
